import type { JSXElementConstructor, ReactNode } from 'react'
import {
  PuiDialog,
  type PuiDialogProps,
  type PuiPopperProps,
} from '@pbt/pbt-ui-components'

export interface PuiPopupProps {
  Component: JSXElementConstructor<any>
  DialogProps?: Partial<PuiDialogProps>
  PopperProps?: Partial<PuiPopperProps>
  children?: ReactNode
  onClose?: () => void
  open: boolean
}

const PuiPopup = ({
  Component,
  DialogProps,
  PopperProps,
  ...rest
}: PuiPopupProps) => {
  const ComponentProps = Component === PuiDialog ? DialogProps : PopperProps

  return <Component {...ComponentProps} {...rest} />
}

export default PuiPopup
